import { env } from '@packages/runtime-config';

const FACEBOOK_PIXEL_ID = '2703696880009704';
const GTM_ID = 'GTM-M2WJMK6G';

function appendInlineScript(code: string) {
  const script = document.createElement('script');
  script.textContent = code;
  document.head.appendChild(script);
}

function loadFacebookPixel() {
  appendInlineScript(`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${FACEBOOK_PIXEL_ID}');
fbq('track', 'PageView');`);
}

function loadGtm() {
  appendInlineScript(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`);
}

/**
 * Counters enabled on the stand by APP_ENABLE_*=1. Called in entry.client before the render:
 * config.js is loaded by then, unlike the shell prerendered at build time.
 */
export function loadAnalytics() {
  if (env.ENABLE_FACEBOOK_PIXEL === '1') {
    loadFacebookPixel();
  }
  if (env.ENABLE_GTM === '1') {
    loadGtm();
  }
}
